const $_ALTENARCONFIG = undefined;
export {$_ALTENARCONFIG};

